import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface DetailPageLayoutProps {
  title: string;
  subtitle?: string;
  backUrl: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
}

export const DetailPageLayout = ({ 
  title, 
  subtitle, 
  backUrl, 
  actions, 
  children 
}: DetailPageLayoutProps) => {
  const navigate = useNavigate();

  return (
    <div className="max-w-7xl mx-auto p-4 sm:p-6 space-y-4 sm:space-y-6 animate-fade-in overflow-x-hidden">
      {/* Header - stacks vertically on mobile */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        {/* Title Section */}
        <div className="flex items-center gap-3 sm:gap-4 min-w-0">
          <Button 
            variant="ghost" 
            size="icon"
            onClick={() => navigate(backUrl)}
            className="shrink-0"
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <div className="min-w-0 flex-1">
            <h1 className="text-xl sm:text-2xl lg:text-3xl font-bold text-foreground truncate">{title}</h1>
            {subtitle && (
              <p className="text-sm sm:text-base text-muted-foreground mt-0.5 sm:mt-1 truncate">{subtitle}</p>
            )}
          </div>
        </div>
        
        {/* Actions - full width on mobile, wrapping enabled */}
        {actions && (
          <div className="flex flex-wrap gap-2 w-full sm:w-auto sm:shrink-0">
            {actions}
          </div>
        )}
      </div>
      {children}
    </div>
  );
};
